import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotContent() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门内容</h2>
            <p className="mt-2 text-foreground-500 text-sm">大家都在看的热门内容，不要错过</p>
          </div>
          <Link
            to="/category/shipin"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
                  热门
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-900 text-sm leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {(article.views / 10000).toFixed(1)}万
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.date}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}